import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { routesConfig } from './loginConfig';
import CommonLayout from '@/layouts/CommonLayout';
import { mapMutations } from 'vuex';
import { login, getRoutesConfig, getCaptcha } from '@/services/user';
import { setAuthorization } from '@/utils/request';
import { loadRoutes } from '@/utils/routerUtil';
import { getPublicData } from '@/services/common';
export default {
  name: 'Login',
  i18n: require('./i18n-login'),
  components: {
    CommonLayout: CommonLayout
  },
  data: function data() {
    return {
      loginForm: {
        useraccount: '',
        password: '',
        code: '',
        captchaCode: ''
      },
      logging: false,
      form: this.$form.createForm(this),
      codesrc: '',
      rules: {
        code: [{
          required: true,
          message: this.$t('login.captchaPH'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('login.pwdPH'),
          trigger: 'blur'
        }],
        useraccount: [{
          required: true,
          message: this.$t('login.useraccountPH'),
          trigger: 'blur'
        }]
      },
      routesConfig: routesConfig
    };
  },
  computed: {
    systemName: function systemName() {
      return this.$store.state.setting.systemName;
    }
  },
  mounted: function mounted() {
    this.init();
    this.showCaptcha();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('account', ['setUser', 'setPermissions', 'setRoles'])), {}, {
    init: function init() {
      getPublicData().then(function (response) {
        //动态修改icon,正式开发,需要通过接口请求,返回ico图标地址,替换link.href
        if (response.data.code == 200) {
          console.log(response);
          window.onload = function () {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = response.data.data.host + response.data.data.storeIcon;
            document.getElementsByTagName('head')[0].appendChild(link);
          };
        }
      });
    },
    showCaptcha: function showCaptcha() {
      var _this = this;
      getCaptcha().then(function (response) {
        _this.codesrc = 'data:image/png;base64,' + response.data.data.bityarray;
        _this.loginForm.captchaCode = response.data.data.uuid;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          login(_this2.loginForm).then(function (result) {
            _this2.logging = true;
            if (result.data.code == 200) {
              //更新成功后更新 最后更新时间
              var data = result.data.data;
              //系统中的金额符号
              localStorage.setItem("leftCurrencySymbol", data.leftCurrencySymbol);
              localStorage.setItem("rightCurrencySymbol", data.rightCurrencySymbol);
              localStorage.setItem("operateType", data.operateType);
              localStorage.setItem("uploadLimit", data.uploadLimit);
              // 发货渠道 0单 1多
              localStorage.setItem('deliveryChannel', data.deliveryChannel);
              setAuthorization({
                token: data.token
              });
              var langList = [];
              var defaultLangObj = {};
              var _iterator = _createForOfIteratorHelper(data.langList),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var item = _step.value;
                  if (item.id == data.defaultLangId) {
                    defaultLangObj.langId = item.id;
                    defaultLangObj.langName = item.name;
                  }
                  langList.push({
                    'langId': item.id,
                    'langName': item.name
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              localStorage.setItem("defaultLangObj", JSON.stringify(defaultLangObj));
              localStorage.setItem("langList", JSON.stringify(langList));
              _this2.setUser(data);
              // 异步加载路由
              // if(localStorage.getItem('deliveryChannel') == '1') {
              // 	let newConfig = _.cloneDeep(this.routesConfig)
              // 	let  obj = newConfig[0]
              // 	obj['children'].forEach(item => {
              // 		if(item.router == 'systemsetting') {
              // 			item.children.splice(2,0,'deliveryChannelManagement')
              // 		}
              // 	})
              // 	this.routesConfig = newConfig
              // }

              // loadRoutes(this.routesConfig)
              _this2.$router.push({
                path: '/home'
              });
              _this2.logging = false;
            } else {
              _this2.showCaptcha();
              _this2.logging = false;
            }
          }).finally(function () {
            _this2.logging = false;
          });
        }
      });
    }
    /* 			afterLogin(res) {
    				this.logging = false
    				const {
    					status,
    					data,
    					message
    				} = res.data;
    				if (status) {
    					this.$store.commit('account/setRoles', [{
    						id: data.userInfo.role == 1 ? "admin" : "",
    						operation: (data.userInfo.role == 1 ? ['add', '删除', 'edit', '开启/关闭'] : [])
    					}])
    					this.setUser(data.userInfo)
    					// this.setPermissions(permissions)
    					// this.setRoles(roles)
    					setAuthorization({
    						token: data.token
    					})
    					// 获取路由配置
    					// getRoutesConfig().then(result => {
    					const routesConfig = data.userInfo.routers;
    					console.log(routesConfig)
    					loadRoutes(routesConfig)
    					this.$router.push("/productmanager/sourcearea")
    					this.$message.success(message, 3)
    					// })
    				} else {
    					this.logging = false;
    					this.$message.error(message);
    				}
    			} */
  })
};